/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
/*! GhostStat — per-card export (CSV · PDF · PNG · copy).
 *
 *  One exporter, mounted into any card's .menubar. A card registers what it HAS — rows, a title, an
 *  optional SVG — and the menu offers only what that makes possible. A card with no rows does not
 *  get a CSV button that produces an empty file.
 *
 *  Everything is generated in the browser from the data already on screen: no export endpoint, no
 *  second query, and therefore no chance of the file disagreeing with the card above it. If the
 *  card is filtered to "mobile, last 7 days", so is the download — that is the whole point.
 */
(function () {
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["export"] = "1"; } catch (e) {}

  var REG = {};   // key -> descriptor

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* RFC 4180. A value containing a comma, quote or newline must be quoted and its quotes doubled —
     otherwise one page title with a comma in it silently shifts every column to its right. */
  function csvCell(v) {
    if (v == null) return "";
    var s = String(v);
    return /[",\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  }
  function toCsv(cols, rows) {
    var out = [cols.map(function (c) { return csvCell(c.label); }).join(",")];
    rows.forEach(function (r) { out.push(cols.map(function (c) { return csvCell(c.get(r)); }).join(",")); });
    // The BOM is for Excel: without it, Excel reads UTF-8 as Latin-1 and "Zürich" becomes "ZÃ¼rich".
    return "\ufeff" + out.join("\r\n");
  }

  function dl(blob, name) {
    var u = URL.createObjectURL(blob), a = document.createElement("a");
    a.href = u; a.download = name; document.body.appendChild(a); a.click();
    setTimeout(function () { URL.revokeObjectURL(u); a.remove(); }, 100);
  }
  function slug(s) { return String(s || "export").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60) || "export"; }
  function stamp(d) {
    var r = (d && d.range) || (window.GS && GS.range) || null;
    return r && r.from && r.to ? r.from + "_" + r.to : new Date().toISOString().slice(0, 10);
  }

  function doCsv(d) {
    var rows = d.rows(), cols = d.cols;
    if (!rows || !rows.length) return;
    dl(new Blob([toCsv(cols, rows)], { type: "text/csv;charset=utf-8" }), slug(d.title) + "-" + stamp(d) + ".csv");
  }

  function doCopy(d) {
    var rows = d.rows(); if (!rows || !rows.length) return;
    // TSV, because that is what a spreadsheet expects off the clipboard
    var t = [d.cols.map(function (c) { return c.label; }).join("\t")];
    rows.forEach(function (r) { t.push(d.cols.map(function (c) { return String(c.get(r) == null ? "" : c.get(r)).replace(/\t/g, " "); }).join("\t")); });
    var s = t.join("\n");
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(s);
    else { var ta = document.createElement("textarea"); ta.value = s; document.body.appendChild(ta); ta.select();
           try { document.execCommand("copy"); } catch (e) {} ta.remove(); }
  }

  /* PNG from the card's own SVG. Serialised, not screenshotted — so the export is the same vector
     the browser drew, at 2x for a display that deserves it. */
  function svgToCanvas(svg, scale, cb) {
    var box = svg.viewBox && svg.viewBox.baseVal;
    var w = (box && box.width) || svg.clientWidth || 800;
    var h = (box && box.height) || svg.clientHeight || 400;
    var clone = svg.cloneNode(true);
    clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    clone.setAttribute("width", w); clone.setAttribute("height", h);
    // inline the computed colours: a detached SVG has no stylesheet, so anything styled by CSS
    // would export black-on-black
    var src = svg.querySelectorAll("*"), dst = clone.querySelectorAll("*");
    for (var i = 0; i < src.length && i < dst.length; i++) {
      var cs = getComputedStyle(src[i]), st = "";
      ["fill", "stroke", "stroke-width", "opacity", "font-size", "font-family", "font-weight", "text-anchor"].forEach(function (p) {
        var v = cs.getPropertyValue(p); if (v) st += p + ":" + v + ";";
      });
      dst[i].setAttribute("style", st);
    }
    var xml = new XMLSerializer().serializeToString(clone);
    var img = new Image();
    img.onload = function () {
      var c = document.createElement("canvas");
      c.width = w * scale; c.height = h * scale;
      var x = c.getContext("2d");
      x.fillStyle = "#fff"; x.fillRect(0, 0, c.width, c.height);
      x.drawImage(img, 0, 0, c.width, c.height);
      cb(c, w, h);
    };
    img.onerror = function () { cb(null); };
    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(xml)));
  }

  function doPng(d) {
    var svg = d.svg && d.svg(); if (!svg) return;
    svgToCanvas(svg, 2, function (c) { if (!c) return; c.toBlob(function (b) { dl(b, slug(d.title) + "-" + stamp(d) + ".png"); }); });
  }

  /* PDF via the print pipeline rather than a bundled PDF library.
   *
   * A real generator (jsPDF + autoTable) is ~350KB on every dashboard load to produce a file the
   * browser can already make — and "Save as PDF" is in every print dialog on every platform. This
   * opens one card, styled for paper, and calls print(). No dependency, no 350KB, and the output is
   * the card as you see it plus the numbers behind it.
   */
  function doPdf(d) {
    var rows = d.rows ? d.rows() : [];
    var w = window.open("", "_blank", "width=980,height=760");
    if (!w) return;                                  // popup blocked: nothing to do but not crash
    var svg = d.svg && d.svg();
    var chart = "";
    if (svg) {
      var c = svg.cloneNode(true);
      c.setAttribute("xmlns", "http://www.w3.org/2000/svg");
      c.removeAttribute("style"); c.setAttribute("width", "100%");
      chart = '<div class="chart">' + new XMLSerializer().serializeToString(c) + "</div>";
    }
    var head = d.cols.map(function (c2) { return "<th>" + esc(c2.label) + "</th>"; }).join("");
    var body = rows.map(function (r) {
      return "<tr>" + d.cols.map(function (c2) { return "<td>" + esc(c2.get(r)) + "</td>"; }).join("") + "</tr>";
    }).join("");
    var r = (d.range && d.range()) || (window.GS && GS.range) || null;
    var site = (window.GS && GS.siteName) || "";
    w.document.write('<!doctype html><meta charset="utf-8"><title>' + esc(d.title) + "</title>" +
      "<style>" +
      "@page{margin:16mm}" +
      "body{font:13px/1.5 'Open Sans',-apple-system,Segoe UI,Roboto,Helvetica,Arial,sans-serif;color:#1A1D24;margin:0}" +
      ".hd{display:flex;align-items:baseline;justify-content:space-between;border-bottom:2px solid #1FA463;padding-bottom:8px;margin-bottom:14px}" +
      "h1{font-size:18px;margin:0;letter-spacing:-.01em}" +
      ".meta{font-size:11px;color:#8C95A1;text-align:right;line-height:1.6}" +
      ".chart{margin:0 0 16px}.chart svg{max-width:100%;height:auto}" +
      "table{border-collapse:collapse;width:100%;font-size:12px}" +
      "th{text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#8C95A1;" +
      "border-bottom:1px solid #E9EDF3;padding:7px 8px}" +
      "td{padding:7px 8px;border-bottom:1px solid #F2F4F8;font-variant-numeric:tabular-nums}" +
      "tr:nth-child(even) td{background:#FAFBFD}" +
      "tfoot{font-size:10px;color:#AAB2BD}" +
      "@media print{.no{display:none}}" +
      "</style>" +
      '<div class="hd"><h1>' + esc(d.title) + "</h1><div class=\"meta\">" +
        (site ? esc(site) + "<br>" : "") +
        (r && r.from ? esc(r.from) + " \u2192 " + esc(r.to) + "<br>" : "") +
        "GhostStat &middot; " + new Date().toLocaleString() +
      "</div></div>" + chart +
      (rows.length ? "<table><thead><tr>" + head + "</tr></thead><tbody>" + body + "</tbody></table>"
                   : '<p style="color:#8C95A1">'+TR('js.no_rows_in_this_range')+'</p>') +
      '<p class="no" style="margin-top:20px;color:#8C95A1;font-size:11px">' +
      "Choose <b>" + TR('js.save_as_pdf') + "</b> as the destination.</p>");
    w.document.close();
    w.focus();
    setTimeout(function () { try { w.print(); } catch (e) {} }, 350);
  }

  function menuHtml(d) {
    var rows = d.rows ? d.rows() : [];
    var has = rows && rows.length;
    var hasSvg = !!(d.svg && d.svg());
    // only offer what this card can actually produce
    return '<div class="xp-menu" role="menu">' +
      (has ? '<button type="button" data-x="csv"><i class="bi bi-filetype-csv"></i> Download CSV</button>' : "") +
      '<button type="button" data-x="pdf"><i class="bi bi-file-earmark-pdf"></i> Save as PDF</button>' +
      (hasSvg ? '<button type="button" data-x="png"><i class="bi bi-image"></i> Download PNG</button>' : "") +
      (has ? '<button type="button" data-x="copy"><i class="bi bi-clipboard"></i> Copy to clipboard</button>' : "") +
      (has ? '<div class="xp-note">' + rows.length.toLocaleString() + " row" + (rows.length === 1 ? "" : "s") +
             ", exactly as filtered above.</div>" : '<div class="xp-note">'+TR('js.nothing_to_export_in_this_range')+'</div>') +
      "</div>";
  }

  function close() {
    document.querySelectorAll(".xp-wrap.open").forEach(function (w) { w.classList.remove("open"); });
  }

  /**
   * mount(el, descriptor)
   *   el         where the button goes (usually a .menubar)
   *   title      used for the filename and the PDF heading
   *   cols       [{ label, get(row) }]
   *   rows()     the rows ON SCREEN — call, do not cache: filters change
   *   svg()      optional, the card's <svg>
   *   range()    optional { from, to }
   */
  function mount(el, d) {
    if (!el || !d || !d.cols || !d.rows) return;
    /* Idempotent. mount() used to appendChild unconditionally, so calling it again — which the
       dashboard did on every metric toggle and every Top-N click — stacked another download button
       into the same menubar. Six clicks, six buttons. A mount function that cannot be called twice
       is a trap, not a contract: remove any previous wrap in this host first. */
    var prev = el.querySelector(":scope > .xp-wrap");
    if (prev) { delete REG[prev.getAttribute("data-xp")]; prev.remove(); }

    var key = "x" + Math.random().toString(36).slice(2, 8);
    REG[key] = d;
    var wrap = document.createElement("span");
    wrap.className = "xp-wrap";
    wrap.setAttribute("data-xp", key);
    wrap.innerHTML = '<button type="button" class="mb xp-btn" title="'+TR('js.export_this_card')+'" aria-haspopup="true" aria-expanded="false">' +
      '<i class="bi bi-download"></i><span class="car">&#9662;</span></button>';
    el.appendChild(wrap);

    wrap.querySelector(".xp-btn").addEventListener("click", function (e) {
      e.stopPropagation();
      var open = wrap.classList.contains("open");
      close();
      if (open) return;
      var old = wrap.querySelector(".xp-menu"); if (old) old.remove();
      wrap.insertAdjacentHTML("beforeend", menuHtml(d));   // built fresh: the row count is current
      wrap.classList.add("open");
      wrap.querySelector(".xp-btn").setAttribute("aria-expanded", "true");
      wrap.querySelectorAll("[data-x]").forEach(function (b) {
        b.addEventListener("click", function (ev) {
          ev.stopPropagation();
          var a = b.getAttribute("data-x");
          if (a === "csv") doCsv(d); else if (a === "pdf") doPdf(d);
          else if (a === "png") doPng(d); else if (a === "copy") doCopy(d);
          close();
        });
      });
    });
    return wrap;
  }

  document.addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === TR('js.escape')) close(); });

  window.GSExport = { mount: mount, csv: doCsv, pdf: doPdf, png: doPng, toCsv: toCsv, csvCell: csvCell };
})();
